import React from 'react';
import moment from 'moment';

const EventTab = ({day, onChange, stateDate}) => {
	let eventTabDate = moment(day.date);
	let activeDayBoolean = moment(stateDate).isBetween(day.start, day.end, null, '[]');
	return (
		<li tabIndex="1" className={`event-tab ${activeDayBoolean ? 'active' : ''}`} onClick={(e) => { onChange(day.start, day.end)}}>
			<time>{eventTabDate.format('dddd')},<br />
				{eventTabDate.format('MMMM D')}</time>
		</li>
	);
}

export default EventTab;


